/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { DepotLocation } from '../../types/locations';

export type DepotStatusType = 'bookable' | 'enable';

interface BookingPageState {
    selectedDepotDetails: DepotLocation | null;
}

const initialState: BookingPageState = {
    selectedDepotDetails: null,
};

const depotSlice = createSlice({
    name: 'depotSlice',
    initialState,
    reducers: {
        setSelectedDepotDetails: (state, action: PayloadAction<DepotLocation>) => {
            const selectedDepotDetails = action.payload;
            state.selectedDepotDetails = selectedDepotDetails;
        },
        updateDepotStatus: (
            state,
            action: PayloadAction<{
                enabled?: boolean;
                bookable?: boolean;
            }>,
        ) => {
            if (!state.selectedDepotDetails) return;

            const { enabled, bookable } = action.payload;

            if (enabled !== undefined) {
                console.log('enable', enabled);
                state.selectedDepotDetails.enabled = enabled; // Access enabled through selectedDepotDetails
            }

            if (bookable !== undefined) {
                console.log('bookable', bookable);
                state.selectedDepotDetails.status = {
                    ...state.selectedDepotDetails.status,
                    bookable,
                };
            }
        },
    },
});

export const { setSelectedDepotDetails, updateDepotStatus } = depotSlice.actions;

export default depotSlice.reducer;
